import React from "react";
import SocialLinks from "./SocialLinks";
import { safeUrl } from "./helpers";

export default function TravelerCard({ item, isAdmin, onEdit, onDelete }) {
  const photoUrl = safeUrl(item.photo?.url);
  const alt = item.photo?.alt || item.title || "Photo voyageur";

  return (
    <article className="tw-card">
      <div className="tw-media">
        {photoUrl ? (
          <img className="tw-img" src={photoUrl} alt={alt} loading="lazy" />
        ) : (
          <div className="tw-imgPlaceholder">Photo</div>
        )}
      </div>

      <div className="tw-cardBody">
        <div className="tw-cardTop">
          <div>
            <h3 className="tw-cardTitle">{item.title}</h3>
            {item.subtitle ? <p className="tw-cardSubtitle">{item.subtitle}</p> : null}
          </div>

          {isAdmin && (
            <div className="tw-cardAdmin">
              <button className="tw-btn tw-btnSmall" onClick={onEdit} type="button">
                Modifier
              </button>
              <button className="tw-btn tw-btnDanger tw-btnSmall" onClick={onDelete} type="button">
                Suppr
              </button>
            </div>
          )}
        </div>

        <div className="tw-links">
          <SocialLinks links={item.links} />
        </div>
      </div>
    </article>
  );
}
